import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit'
import type { User } from '../../types/user';

type UserState = {
  user: User | null;
  allowSmsDialogOpened: boolean
}

const initialState: UserState = {
  user: null,
  allowSmsDialogOpened: false
};

const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
      setUser: (state, action: PayloadAction<User>) => { 
        state.user = action.payload;
      },
      removeUser: (state) => {
          state.user = null
    },
    openAllowSmsDialog: (state) => {
        state.allowSmsDialogOpened = true
    },
    closeAllowSmsDialog: (state) => {
        state.allowSmsDialogOpened = false
      }
    }
});

export const { setUser, removeUser, openAllowSmsDialog, closeAllowSmsDialog } = userSlice.actions
export default userSlice;
